import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { Product } from '../../../models/product';
import { InfoBoxComponent } from 'app/shared/components/info-box/info-box.component';

@Component({
    selector: 'app-info-sidebar',
    imports: [InfoBoxComponent],
    templateUrl: './info-sidebar.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InfoSidebarComponent {
    public product = input.required<Product>();
}
